<div class="capability-card">
  <span class="capability-card-icon">
    <lucide-icon *ngIf="icon" [name]="icon"></lucide-icon>
  </span>
  <div class="capability-card-content">
    <h3 class="capability-card-title">{{ title }}</h3>
    <ul class="capability-card-list">
      <li *ngFor="let item of items">{{ item }}</li>
    </ul>
  </div>
</div>